import type { CV } from '../types/cv'

interface CompletenessResult {
  score: number // 0-100
  sections: SectionStatus[]
}

interface SectionStatus {
  id: string
  label: string
  completed: boolean
  weight: number
}

export function calculateCompleteness(cv: CV): CompletenessResult {
  const sections: SectionStatus[] = [
    {
      id: 'name',
      label: 'name',
      completed: Boolean(cv.personalInfo?.fullName?.trim()),
      weight: 15,
    },
    {
      id: 'title',
      label: 'title',
      completed: Boolean(cv.personalInfo?.title?.trim()),
      weight: 10,
    },
    {
      id: 'contact',
      label: 'contact',
      completed: Boolean(cv.personalInfo?.email?.trim() || cv.personalInfo?.phone?.trim()),
      weight: 10,
    },
    {
      id: 'summary',
      label: 'summary',
      completed: Boolean(cv.summary?.trim() && cv.summary.trim().length > 20),
      weight: 15,
    },
    {
      id: 'experience',
      label: 'experience',
      completed: Boolean(
        cv.experience?.some(exp => exp.company?.trim() || exp.position?.trim())
      ),
      weight: 20,
    },
    {
      id: 'education',
      label: 'education',
      completed: Boolean(
        cv.education?.some(edu => edu.institution?.trim() || edu.degree?.trim())
      ),
      weight: 15,
    },
    {
      id: 'skills',
      label: 'skills',
      completed: Boolean(
        (cv.skills?.technical && cv.skills.technical.length > 0) ||
        (cv.skills?.soft && cv.skills.soft.length > 0) ||
        (cv.skills?.tools && cv.skills.tools.length > 0)
      ),
      weight: 10,
    },
    {
      id: 'languages',
      label: 'languages',
      completed: Boolean(
        cv.languages?.some(lang => lang.name?.trim())
      ),
      weight: 5,
    },
  ]

  const totalWeight = sections.reduce((sum, s) => sum + s.weight, 0)
  const completedWeight = sections
    .filter(s => s.completed)
    .reduce((sum, s) => sum + s.weight, 0)

  const score = Math.round((completedWeight / totalWeight) * 100)

  return { score, sections }
}
